import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs';
import { OfferService } from '@/service/offer.service';
import { Category } from '@/model/category';
import { OfferWithImage } from '@/model/offer-with-image';
import * as TrendingCategoriesActions from './trending-categories.actions';

@Injectable()
export class TrendingCategoriesEffects {
  loadTrendingData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TrendingCategoriesActions.loadTrendingData),
      switchMap(() =>
        this.offerService.getAllOffersWithImages(99999, 0).pipe(
          map((offers) => offers.filter((o) => o.status === 'APPROVED')),
          map((offers) => {
            const categories = this.deriveParentCategories(offers);
            return TrendingCategoriesActions.loadTrendingDataSuccess({
              offers,
              categories,
            });
          }),
          catchError((error) => [
            TrendingCategoriesActions.loadTrendingDataFailure({ error }),
          ]),
        ),
      ),
    ),
  );

  applyInitialCategoryFilter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TrendingCategoriesActions.loadTrendingDataSuccess),
      map(() => TrendingCategoriesActions.applyInitialCategoryFilter()),
    ),
  );

  constructor(
    private actions$: Actions,
    private offerService: OfferService,
  ) {}

  private deriveParentCategories(offers: OfferWithImage[]): Category[] {
    const categoryCount = new Map<
      string,
      { category: Category; count: number }
    >();

    offers.forEach((offer) => {
      offer.categories.forEach((category) => {
        if (
          category.parentId === null ||
          typeof category.parentId === 'undefined'
        ) {
          if (!categoryCount.has(category.id)) {
            categoryCount.set(category.id, { category, count: 1 });
          } else {
            const current = categoryCount.get(category.id)!;
            current.count++;
          }
        }
      });
    });

    return Array.from(categoryCount.values())
      .sort((a, b) => b.count - a.count)
      .slice(0, 4)
      .map((item) => item.category);
  }
}
